export enum VerificationPortalType {
    verificationPortal,
    document,
    envelope
}